// extracted by mini-css-extract-plugin
export default {"product__main":"ProductMain_product__main__TjlbE","product__top":"ProductMain_product__top__tbSRJ","product__container":"ProductMain_product__container__8sYQh"};